import React from 'react';

import { Box } from '@chakra-ui/react';

import { StrapiImage } from '@/components/atoms';
import { ImageFragment } from '@/graphql/generated';
import { getImageAlt, getImageSrcWithBlurhash } from '@/utils/images';

type CoverImageProps = {
  cover: ImageFragment;
};

export const CoverImage = ({ cover }: CoverImageProps) => {
  return (
    <Box
      as={StrapiImage}
      image={cover}
      {...getImageSrcWithBlurhash(cover?.data?.attributes)}
      alt={getImageAlt(cover?.data?.attributes)}
      objectFit={{
        base: 'scale-down',
        sm: 'contain',
      }}
      boxShadow="-24px 10px 40px rgba(66, 68, 90, 0.25)"
    />
  );
};
